import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing }: Theme) => createStyles({
  link: {
    marginBottom: spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
});

export default styles;
